



































import { Component, Vue } from "vue-property-decorator";
import { Action, Getter, State, namespace } from "vuex-class";

import { Evidence, Match } from "@/types";
import BaseToken from "@/components/BaseToken.vue";
import BaseTab from "@/components/BaseTab.vue";
import MatchedDocument from "@/components/MatchedDocument.vue";
import EvidencedDocument from "@/components/EvidencedDocument.vue";

const Details = namespace("details");

const Evidences = namespace("evidences");

const Matches = namespace("matches");

@Component({
  components: { EvidencedDocument, MatchedDocument, BaseTab, BaseToken }
})
export default class CombinedDocument extends Vue {
  private tab: string = "0";

  @State("text")
  private text!: string;

  @Getter("matches/parsed")
  private indexed!: (type: string) => Match[];

  @Action("details/update")
  show!: (value: Match) => void;

  @Details.State("evidence")
  private evidence!: Evidence | null;

  @Evidences.Getter("parsed")
  private evidences!: Evidence[][];

  @Matches.Getter("flatten")
  private matches!: Match[][];
}
